import { render, staticRenderFns } from "./TagsRemoved.vue?vue&type=template&id=09e10363&scoped=true"
import script from "./TagsRemoved.vue?vue&type=script&lang=js"
export * from "./TagsRemoved.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09e10363",
  null
  
)

export default component.exports